exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer[data-v-01c5283c]{display:table\n}\n.footer .logos[data-v-01c5283c]{display:flex;align-items:center;justify-content:center;margin-bottom:10px\n}\n.footer .logos img[data-v-01c5283c]{display:table-cell;width:100%;max-width:140px;margin:0 20px\n}\n.footer .logos img.club[data-v-01c5283c]{max-height:100px\n}\n.footer ul[data-v-01c5283c]{margin-bottom:15px;color:#555;padding-left:0\n}\n.footer ul li[data-v-01c5283c]{display:inline-block;padding:0 10px\n}\n.footer ul li a[data-v-01c5283c]{color:#555 !important;text-decoration:none\n}\n.footer ul li a[data-v-01c5283c]:hover{color:#000 !important;text-decoration:underline\n}\n.footer ul li.terms[data-v-01c5283c]{padding:0 5px\n}\n.footer ul li.terms a[data-v-01c5283c]{font-size:0.9rem;color:#777 !important\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01c5283c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Footer.vue
// module id = 274
// module chunks = 0